<button class="btn btn--more" tabindex="0" title="Sluit" modal-close-btn>
    <span>Sluit</span>
    <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
</button>
<div modal-title>&nbsp;</div>
<div modal-content e2e="bm-modal">
    <p>{{ modalData.purchased_product_addition.note_deviation_no_claim_years_bonus_malus }}</p>
    <div class="bonus-malue-footer">
        <button class="btn btn--primary" (click)="close()" e2e="modal_submit">Oké, begrepen</button>
    </div>
</div>
